document.addEventListener('DOMContentLoaded', function() {
  const translate = () => {
    const lang = document.documentElement.lang;
    if (!lang.startsWith('ja')) return;
    const map = {
      'Features': '特徴',
      'Specification': '仕様',
      'Delivery & Warranty': '配送と保証'
    };
    document.querySelectorAll('[role="tab"]').forEach(el => {
      const text = el.textContent.trim();
      if (map[text]) el.textContent = map[text];
    });
  };
  translate();
  setTimeout(translate, 500);
  setTimeout(translate, 1500);
});
